export default __webpack_public_path__ + "static/media/img-fireplaces.799800f1.png";